const config = {
    API_URL: process.env.REACT_APP_API_URL,
    DISABLE_SUBSCRIPTION: process.env.REACT_APP_DISABLE_SUBSCRIPTION ? !!parseInt(process.env.REACT_APP_DISABLE_SUBSCRIPTION) : false,
};

export default config;
